import { CAPACITY, CREW, WEEK } from '../constants';
import { maxCapacityCrew } from '../helpers/crew';
import { getPricePerPerson } from '../helpers/pricing';

export const initialState = {
  items: [],
  mostExpensiveYacht: null,
  cheapestYacht: null,
  // available: [],
  filtered: [],
  selectedTypes: [],
  selectedHulls: [],
  selectedAmenities: [],
  selectedPartners: [],
  selectedMarina: '',
  selectedBoatYear: null,
  selectedBoatCabins: null,
  selectedBoatSize: null,
  // currency: undefined,
  sortBy: {
    value: 1,
    label: 'Recommended'
  },
  lastUpdated: undefined,
  capacity: {
    minCapacity: CAPACITY.MIN,
    maxCapacity: CAPACITY.MAX
  },
  priceRange: {
    min: null,
    max: null
  }
};

export const filterYachtsByWeek = (state, payload) => {
  const { weeks, destination } = payload;
  return state.items.filter(item => {
    if (destination.id !== parseInt(item.week.destinationId, 10)) {
      return false;
    }
    return weeks.indexOf(parseInt(item.week.id, 10)) !== -1;
  });
};

export const filterYachts = (state, payload) => {
  const {
    hullType = [],
    amenities = [],
    marina = [],
    partners = [],
    capacity = {},
    boatYear = [],
    boatCabins = [],
    boatSize = [],
    priceRange = {},
    weekFilter = [],
    yearFilter = [],
    countryFilter = [],
    festivalFilter = [],
    favourites = null,
    deals = null
  } = payload;
  let { yachtTypes = [] } = payload;
  yachtTypes = yachtTypes.map(type => parseInt(type, 10));
  return state.items.filter(item => {
    // Now you can actually visit the page without selecting week so nothing is stopping you from seeing yachts from forbidden statuses
    if ([WEEK.COMING_SOON_STATUS, WEEK.SOLD_OUT_STATUS].includes(item.week.status)) {
      return false;
    }
    if (favourites && !item.isSavedPlan) {
      return false;
    }
    if (deals && item.isDeal !== true) {
      return false;
    }
    if (capacity.minCapacity > parseInt(item.boat.capacity - 1, 10)) {
      return false;
    }
    if (capacity.maxCapacity < parseInt(item.boat.capacity - 1, 10) && capacity.maxCapacity !== CREW.MAX_GUESTS) {
      return false;
    }

    if (yachtTypes.length > 0 && yachtTypes.indexOf(item.boat.ratingId) === -1) {
      return false;
    }
    if (marina.length > 0 && marina.indexOf(item.marina.name) === -1) {
      return false;
    }
    if (hullType.length > 0 && hullType.indexOf(item.boat.hullType) === -1) {
      return false;
    }
    if (boatCabins.length > 0 && boatCabins.indexOf(`${item.boat.cabins}`) === -1) {
      return false;
    }
    if (boatSize.length > 0 && boatSize.indexOf(`${item.boat.size}`) === -1) {
      return false;
    }
    if (boatYear.length > 0 && boatYear.indexOf(`${item.boat.year}`) === -1) {
      return false;
    }
    // if (boatCabins && boatCabins > item.boat.cabins) {
    //   return false;
    // }
    // if (boatSize && boatSize > item.boat.size) {
    //   return false;
    // }
    const hasAC = item.boat.attributes.indexOf(1) !== -1 && item.boat.attributes.indexOf(2) !== -1;
    if (amenities.length > 0 && amenities.indexOf('Air Conditioning') !== -1 && !hasAC) {
      return false;
    }
    if (partners.length && !partners.includes(item.boat.partner.id)) {
      return false;
    }
    if (weekFilter.length && !weekFilter.includes(`${item.week.week}`)) {
      return false;
    }
    if (festivalFilter.length && !festivalFilter.includes(`${item.week.id}`)) {
      return false;
    }
    // if (destinationFilter.length && !destinationFilter.includes(`${item.week.destinationId}`)) {
    //   return false;
    // }
    if (countryFilter.length && !countryFilter.includes(`${item.week.destinationCountry}`)) {
      return false;
    }
    if (yearFilter.length && !yearFilter.includes(new Date(item.week.beginDate).getFullYear().toString())) {
      return false;
    }
    // if (yearFilter.length && !yearFilter.includes(`${item.week.year}`)) {
    //   return false;
    // }
    const perPersonPrice = getPricePerPerson(item, maxCapacityCrew(item.boat.capacity));
    if (perPersonPrice > priceRange.max || perPersonPrice < priceRange.min) {
      return false;
    }
    return true;
  });
};

const yachts = (state = initialState, action) => {
  switch (action.type) {
  case 'FETCH_YACHTS': {
    return {
      ...state,
      items: action.data,
      lastUpdated: Date.now()
    };
  }
  case 'SAVE_YACHTS': {
    return {
      ...state,
      items: action.boatWeeks,
      mostExpensiveYacht: action.mostExpensiveYacht,
      cheapestYacht: action.cheapestYacht
    };
  }

  case 'FILTER_YACHTS_BY_WEEK': {
    const filteredByWeek = filterYachtsByWeek(state, action.payload);
    return {
      ...state,
      filtered: filteredByWeek
    };
  }

  case 'FILTER_YACHTS':
    return {
      ...state,
      filtered: filterYachts(state, action.payload)
    };

  case 'SORT_BY':
    return {
      ...state,
      sortBy: action.criteria
    };

    // case 'CHANGE_CURRENCY':
    //   return {
    //     ...state,
    //     currency: action.currency,
    //   };

  case 'RESET_SEARCH_CRITERIA':
    return {
      ...state,
      selectedTypes: [],
      selectedHulls: [],
      selectedAmenities: [],
      marina: '',
      // currency: undefined,
      sortBy: {
        value: 1,
        label: 'Recommended'
      }
    };

  default:
    return state;
  }
};

export default yachts;
